(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-hero-prodotto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kv-sticky-buy')) {
    customElements.define(
      'kv-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          const hero = this.previousElementSibling;
          if (!hero) return;
          this.observer = new IntersectionObserver(([entry]) => {
            const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-shown', passed);
          });
          this.observer.observe(hero);
        }
        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kv-target"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kv-tabs')) {
    customElements.define(
      'kv-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
              event.preventDefault();
              const step = event.key === 'ArrowRight' ? 1 : -1;
              const next = (index + step + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            const selected = i === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !selected;
          });
        }
      }
    );
  }
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('.kv-target__panel');
    const tabs = panel && panel.closest('kv-tabs');
    if (!tabs) return;
    const index = tabs.tabs.findIndex((tab) => tab.getAttribute('aria-controls') === panel.id);
    if (index > -1) tabs.select(index);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
